"use client";

import React from "react";
import { motion } from "framer-motion";

const metrics = [
    {
        label: "Products Shipped",
        value: "40+",
        description: "Built with intent. From zero to scale."
    },
    {
        label: "Users Scaled",
        value: "10K+",
        description: "Products that ship. Real human impact."
    },
    {
        label: "Capital Raised",
        value: "$50M+",
        description: "Success defined by execution over noise."
    }
];

export const ImpactSection = () => {
    return (
        <section className="relative py-40 px-4 bg-white text-black overflow-hidden">
            <div className="max-w-[1400px] mx-auto space-y-24">
                <motion.h2 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="font-display text-4xl md:text-6xl uppercase leading-[1.1] tracking-tighter max-w-4xl"
                >
                    Behind every product is <br />
                    a decision made right.
                </motion.h2>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-24 border-t border-black/10 pt-12">
                    {metrics.map((metric, index) => (
                        <motion.div 
                            key={metric.label}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
                            className="space-y-6"
                        >
                            <span className="micro-id tracking-[0.4em] text-black/60 uppercase">{metric.label}</span>
                            <div className="space-y-4">
                                <div className="font-display text-8xl md:text-9xl leading-[1.1]">
                                    {metric.value}
                                </div>
                                <p className="font-sans text-xl text-black/70 max-w-xs uppercase tracking-tight leading-tight">
                                    {metric.description}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
            
            {/* Subtle premium visual detail: Noise overlay */}
            <div className="bg-noise opacity-5 invert pointer-events-none" />
        </section>
    );
};
